import PropTypes from 'prop-types';
import React from 'react';
import RatesAuditActions from '../Actions/RatesAuditActions';
import AutoScopeStylesDecorator from '../../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import DisableOnActionInProgress from '../../../../Common/Components/DisableOnActionInProgress.jsx';
import NotificationActions from '../../../../Common/Actions/NotificationActions';
import { validate } from '../Validators/DateRangeValidator';
import DatePickerView from '../../../../Common/Components/Forms/DatePickerView.jsx';
import Moment from 'moment';
import ClassNames from 'classnames';
import applyDecoratorsDoNotUseInNewCode from '../../../../Common/Utilities/Decorators/ApplyDecorators';

function getStateChanges(props) {
    const validationState = validate(props.searchCriteria.from, props.searchCriteria.to);
    return {
        validationState,
        from: props.searchCriteria.from,
        to: props.searchCriteria.to
    };
}

function validateAndExecute(validationState, action, actionOnInvalid) {
    if(validationState.valid) {
        NotificationActions.clearNotifications('validation');
        action();
    } else {
        RatesAuditActions.searchResultsInvalidated();
        NotificationActions.notificationReceived({
            title: 'Please fix the issues below:',
            icon: 'warning',
            severity: 'failure',
            category: 'validation',
            messages: Object.keys(validationState.errors)
                .map(key => validationState.errors[key])
                .filter((value, index, self) => self.indexOf(value) === index)
        });

        if(actionOnInvalid)
            actionOnInvalid();
    }
}

class RatesAuditSearchView extends React.Component {
    constructor(props) {
        super(props);
        this.state = getStateChanges(props);
    }

    componentDidUpdate(prevProps) {
        if(JSON.stringify(this.props) !== JSON.stringify(prevProps)) {
            this.setState(getStateChanges(this.props));
        }
    }

    render() {
        const toDateString = (value) => Moment(value).isValid() ? Moment(value).format('YYYY-MM-DD') : null;
        const validationState = this.state.validationState;
        const renderDatePicker = (label, lookup, callback) => {

            return (
                <div className="inline field">
                    <label>{ label }</label>
                    <DatePickerView
                        value={ toDateString(this.state[lookup]) }
                        onChange={ callback }
                        className={ ClassNames('field', { error: validationState.errors[lookup] }) }
                    />
                </div>
            );
        };
        return (
            <div className="segment">
                <form>
                    <div className="filters">
                        { renderDatePicker('Filter from', 'from', this.onFromChanged) }
                        { renderDatePicker('Filter to', 'to', this.onToChanged) }
                    </div>

                    <div className="right aligned container">
                        <DisableOnActionInProgress>
                            <button
                                id="View"
                                type="submit"
                                className="primary button"
                                onClick={ this.onViewClicked }>
                                View
                            </button>
                            <button
                                id="DownloadAuditReport"
                                type="button"
                                className="button"
                                onClick={ this.onDownloadAuditReportClicked }>
                                Download audit report
                            </button>
                        </DisableOnActionInProgress>
                    </div>
                </form>
            </div>)
    }

    toDate = (value) => Moment(value).isValid() ? Moment(value).toDate() : null;
    onFromChanged = (from) => this.setState({ from: this.toDate(from) });
    onToChanged = (to) => this.setState({ to: this.toDate(to) });

    setValidationStateAndExecuteAction = (action, actionOnInvalid) => this.setState({ validationState: validate(this.state.from, this.state.to) }, () => validateAndExecute(this.state.validationState, action, actionOnInvalid));
    onViewClicked = (event) => {
        event.preventDefault();
        this.setValidationStateAndExecuteAction(
            () => this.props.onViewRequested({ from: this.state.from, to: this.state.to, valid: true }),
            () => this.props.onViewRequested({ from: this.state.from, to: this.state.to, valid: false }))
    }
    onDownloadAuditReportClicked = () => this.setValidationStateAndExecuteAction(() => this.props.onDownloadAuditReportRequested({ from: this.state.from, to: this.state.to }));

    static propTypes = {
        searchCriteria: PropTypes.object,
        onViewRequested: PropTypes.func.isRequired,       // onViewRequested({ from: Date(), to: Date(), valid: Boolean }), which are always valid dates for an interval [from, to), or null date(s) if invalid
        onDownloadAuditReportRequested: PropTypes.func.isRequired // onDownloadAuditReportRequested({ from: Date(), to: Date() })
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStylesDecorator);

export default withDecorators(RatesAuditSearchView);
